var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFeedback = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.375.813a.812.812 0 0 1 .813.812v6.5a.812.812 0 0 1-.813.813H3.586c-.43 0-.844.17-1.148.476L.812 11.039V1.625a.812.812 0 0 1 .813-.813h9.75ZM1.625 0A1.625 1.625 0 0 0 0 1.625v10.394a.406.406 0 0 0 .694.287l2.318-2.318a.813.813 0 0 1 .574-.238h7.789A1.625 1.625 0 0 0 13 8.125v-6.5A1.625 1.625 0 0 0 11.375 0h-9.75Z",
  fill: "#3B3B3B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.741 3.868a1.353 1.353 0 0 0-2.491.737 1.354 1.354 0 0 0 2.08 1.143c-.106.316-.304.653-.63.99a.339.339 0 1 0 .487.472c1.207-1.251 1.05-2.611.554-3.34v-.002Zm3.25 0a1.353 1.353 0 0 0-2.491.737 1.354 1.354 0 0 0 2.08 1.143c-.106.316-.304.653-.63.99a.339.339 0 1 0 .487.472c1.207-1.251 1.05-2.611.554-3.34v-.002Z",
  fill: "#3B3B3B"
})));
export default SvgFeedback;